import { CustomFilterPillProps } from "../../../../SharedComponents/Interfaces/CustomFilterPill.interfaces";

export const FILTER_PILL = {
  INITIAL_STATE: { menuItems: [], selectedMenuItems: [] },
  INITIAL_DATA: [] as CustomFilterPillProps[]
};

export const FILTERABLE_REVENUE_FIELDS = ["serviceFamily", "serviceName", "acrProductName", "endOfMonth"] as const;
export const MSSALES_REQUEST_LINK = "https://euaaccessportal.microsoft.com/request/access/MSSales";
export const PERMISSION_MESSAGE = "You don't have permission to view this page.";
export const NO_DATA_MESSAGE = "Revenue details are not available for this product.";